<template>
  <vx-tooltip :text="$t(tooltip) | capitalize">
    <feather-icon
      :icon="icon"
      :style="customStyle || null"
      :class="customClass || null"
      svgClasses="hover:opacity-80 cursor-pointer action-block"
      @click="$emit('click')"

    />
  </vx-tooltip>
</template>

<script>
export default {
  name: 'BaseActionIcon',
  props: {
    tooltip: {
      type: String,
      default: 'Tooltip'
    },
    icon: {
      type: String,
      default: 'EditIcon'
    },
    customStyle: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: null
    }
  }
};
</script>